import * as React from 'react'
import ContentDialog from './ContentDialog'

export interface IConfirmDialogProps {
  open: boolean
  title?: string
  message: string
  onClose: () => void
  onYes?: () => void
}

export default function ConfirmDialog(props: IConfirmDialogProps) {
  const { open, title, message, onClose, onYes } = props

  const handleYes = () => {
    if (onYes && onYes !== null) {
      onYes()
    }
    onClose()
  }

  return (
    <ContentDialog
      open={open}
      onClose={onClose}
      title={title || '❓ Confirme'}
      buttons={[
        { title: 'Não', type: 'negative', onClick: onClose },
        { title: 'Sim', type: 'positive', onClick: handleYes },
      ]}
    >
      {message}
    </ContentDialog>
  )
}
